// extracted by mini-css-extract-plugin
export default {"loader":"LoaderInCentalPosition_loader__IlGjV"};